import { useEffect, useState } from "react";
import CardLayout1 from "./CardLayout1"
import { getStopovers } from "../services/API";
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import type { carousel } from "../Types";


const StopoversToursContainer: React.FC<carousel>= ({keyWord, title}) => {
    
    const [tours, setTours] = useState([]);

    const safeKeyWord = keyWord.replace(/[^a-zA-Z0-9]/g, "-");

    const initData = async () => {
        const data = await getStopovers(keyWord)
        if (data) {
            setTours(data)
        }
    }

    useEffect(() => {
        initData()
    }
    ,[])


    return (
        <>
        { tours.length ? 
            <section className="app-section container-fluid py-0 pt-4 pt-md-5">
                    <div className="container px-md-0">

                        {/* Heading + Button */}
                        <div className="row text-start pb-4 pb-md-5 align-items-center">
                            <h2 className="fw-bold fs-4 col pt-2">{title}</h2>

                            {title !== "Other stopovers" && (
                                <div className="col-12 col-md-3 d-none d-lg-flex justfify-content-end">
                                    <a href="/tours/filter/tours?sortby=popular&holidaystyle=stopovers&substyle=stopovers#/"
                                    className="btn btn-tf-orange rounded-0 btn-lg text-white w-100 text-nowrap">
                                    <span>View all stopovers</span></a>
                                </div>
                            )}
                        </div>

                        {/* Carousel */}
                        <Swiper
                            modules={[Navigation, Pagination, Scrollbar, A11y]}
                            spaceBetween={20}
                            slidesPerView={1.2}
                            loop={false}
                            wrapperClass="align-items-stretch"
                            className="mySwiper h-100"
                            navigation={{
                                nextEl : `.swiper-next-${safeKeyWord}`,
                                prevEl : `.swiper-prev-${safeKeyWord}`
                            }}
                            pagination={{
                                el: `.swiper-pagination-${safeKeyWord}`,
                                clickable: true
                            }}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1.4,
                                    spaceBetween: 14,
                                    pagination: {enabled: true}
                                },
                                768: {
                                    slidesPerView: 2.1,
                                    spaceBetween: 18,
                                    pagination: {enabled: true}
                                },
                                1024: {
                                    slidesPerView: 3.5,
                                    spaceBetween: 20,
                                    pagination: {enabled: false}
                                },
                            }}
                        >

                            {tours.map((tour: any) => {
                                return (
                                    <SwiperSlide 
                                        key={tour.entryId ?? tour.DDLink}
                                        className="h-auto d-flex align-items-stretch">
                                            <CardLayout1
                                                image={tour.DDImage}
                                                title={tour.DDTourName}
                                                tourType={tour.DDTourType}
                                                duration={tour.DDDuration}
                                                introduction={tour.Introduction_txt}
                                                href={tour.DDLink}
                                            />
                                    </SwiperSlide>
                                )
                            })}
                        </Swiper>

                        <div className="d-flex justify-content-center d-lg-none mt-3">
                            <div id={`swiper-pagination-${safeKeyWord}`}/>
                        </div>

                        <div className='container-fluid d-flex justify-content-center text-dark mt-4 mb-0 '>
                            <div className={`swiper-prev-${safeKeyWord} cursor-pointer d-none d-lg-flex`}>
                                <i className='btn btn-light rounded-circle icon-chevron_left glyph-sm p-3 me-4' role="back button"></i>
                            </div>
                            <div className={`swiper-next-${safeKeyWord} cursor-pointer d-none d-lg-flex`}>
                                <i className='btn btn-light rounded-circle icon-chevron_right glyph-sm p-3' role="next button"></i>
                            </div>
                        </div>


                        {/* Only show button when on mobile/tablet view at the bottom of the section */}
                        <div className="col-12 d-lg-none mt-0 justify-content-center text-center">
                            {title !== "Popular stopovers on the way to Australia & New Zealand" && (
                            <div className="d-block d-lg-none mt-2">
                                <a href="/tours/filter/tours?sortby=popular&holidaystyle=stopovers&substyle=stopovers#/"
                                className="btn btn-tf-orange rounded-0 btn-lg text-white w-80">
                                <span>View all stopovers</span></a>
                            </div>
                            )}
                        </div>
                    

                    </div>
            </section>    
        : " "}  
        </>
    )
}

export default StopoversToursContainer